/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class CartLink extends HTMLElement {
    constructor() {
        super();
        this.itemsCount = this.querySelector("items-count");
    }
    connectedCallback() {
        this.unsubscribe = Cart.subscribe((state => {
            this.itemsCount.innerHTML = state.cart.item_count.toString();
            // Gardenmac 29/09/2026: la bolla si nasconde a carrello vuoto (CSS su .js-cart-full in gm-stile)
            const link = this.querySelector(".js-cart-icon");
            if (link) link.classList.toggle("js-cart-full", state.cart.item_count > 0);
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
}

customElements.define("cart-link", CartLink);
//# sourceMappingURL=cart-link.js.map
